import { Variants } from 'framer-motion'
import { theme } from 'styles/theme'

export const variants: Variants = {
  animate: {
    opacity: 1,
    translateY: '0%',
    transition: {
      type: 'tween',
      duration: 0.3,
      ease: theme.easeValues.inOut,
    },
  },
  up: {
    opacity: 0,
    translateY: '-100%',
    transition: {
      type: 'tween',
      duration: 0.3,
      ease: theme.easeValues.inOut,
    },
  },
  down: {
    opacity: 0,
    translateY: '100%',
    transition: {
      type: 'tween',
      duration: 0.3,
      ease: theme.easeValues.inOut,
    },
  },
}
